<ng-container *ngIf="score.hasOwnProperty('offers')">
  <div class="no-offer">
    <img src="/assets/icons/caution.svg" alt="Ícono de información azul" class="no-offer__icon" />
    <h2 class="no-offer__title customer">Recupera el monto de tu cuota máxima mensual</h2>
    <p class="no-offer__description customer">
      Actualmente tu cuota máxima mensual disponible es de
      <span>{{ score?.score | powerpayCurrency }}</span
      >. Para recuperar el monto, puedes:
    </p>
    <div class="no-offer__box">
      <div class="no-offer__box__installments">
        <img src="/assets/icons/blue-bullet.svg" alt="Viñeta azul" class="blue-bullet" />
        <p class="amount">Adelantar el pago de parte de la deuda (el monto de una o más cuotas).</p>
      </div>
      <div class="no-offer__box__installments">
        <img src="/assets/icons/blue-bullet.svg" alt="Viñeta azul" class="blue-bullet" />
        <p class="amount">Anticipar el pago total de tu deuda.</p>
      </div>
    </div>
    <span class="no-offer__phrase">O bien, buscar un producto de monto inferior</span>
    <div class="no-offer__blue-button">
      <button class="btn-primary-bg" (click)="onRedirectToServicingPortal()">Adelantar pago</button>
    </div>
    <div class="no-offer__simple-btn">
      <button class="no-fill" (click)="onCloseNoOfferError()">Explorar otros productos</button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="score.hasOwnProperty('others')">
  <div class="no-offer">
    <img src="/assets/icons/caution.svg" alt="Ícono de información azul" class="no-offer__icon" />
    <h2 class="no-offer__title no-customer">Revisa el monto de tu compra</h2>
    <p class="no-offer__description no-customer">
      En esta ocasión, no podemos aprobar tu solicitud para este monto de compra.<br />
      <br />
      Puedes financiar:
    </p>
    <div class="no-offer__box">
      <div class="no-offer__box__installments" *ngFor="let installment of installments">
        <img src="/assets/icons/blue-bullet.svg" alt="Viñeta azul" class="blue-bullet" />
        <p class="amount">
          Hasta <span>{{ installment?.amount | powerpayCurrency }}</span> a
          {{ installment?.number }} cuotas.
        </p>
      </div>
    </div>
    <span class="no-offer__phrase">Por favor, busca un producto de monto inferior</span>
    <div class="no-offer__blue-button">
      <button class="btn-primary-bg" (click)="onCloseNoOfferError()">
        Explorar otros productos
      </button>
    </div>
  </div>
</ng-container>
